import React from 'react';
import { ButtonBase } from '@mui/material';

function Tab({ tabs, activeTab, onTabChange }) {
    return (
        <div className="tab_Sec_box">
            <div className="tab_Sec flex gap-[0_30px]">
                {tabs.map((tab, idx) => (
                    <ButtonBase key={idx}>
                        <div
                            className={`tab_menu ${activeTab === idx ? 'active' : ''}`}
                            onClick={() => onTabChange(idx)}
                        >
                            {tab}
                        </div>
                    </ButtonBase>
                ))}
            </div>
        </div>
    );
}

export default Tab;
